export default "__VITE_ASSET__B3gbpTc6__"